import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDrawer } from '../../../shared/drawer';
import { useStore } from '../../../shared/store';
import { PageBody } from '../../../elements/page-body';
import { Table } from '../../../elements/table';
import { JobsForm } from './jobs-form';
import { JobsFilter } from './jobs-filter';
import { RenderFilters } from '../../../elements/render-filters';
//import { CentrosForm } from './centros-form';


export const Jobs = () => {
    const { open, close } = useDrawer();
    const [refresh, setRefresh] = useState<string | null>(null);
    const [filters, setFilters] = useState<any>({});
    const [query, setQuery] = useState<any>(new URLSearchParams(filters));




    const handleNewAction = () => {
        open('common.label.nuevo-encargo', <JobsForm close={handleClose} />);
    };

    const handleClose = () => {
        setRefresh(Date.now().toString());
        close();
    };

    const handleFilters = () => {
        open('common.filter.title', <JobsFilter close={close} doFilter={doFilter} item={filters} />);
    };

    const openInNewTab = (item: any) => {
        window.open(item.photo, '_blank', 'noreferrer');
    };

    const doFilter = (filters: any) => {
        setFilters(filters);
        // Actualizar el query inmediatamente con los nuevos filtros
        setQuery(new URLSearchParams(filters));
        // Resetear la paginación cuando se aplica un filtro
        setRefresh(Date.now().toString());
        close();
    };


    return (
        <PageBody
            newAction={handleNewAction}
            title={'common.label.encargos'}
            newActionTitle={'common.form-title.new'}
            filterAction={handleFilters}
            filters={filters}
        >
            <>

                {Object.keys(filters).length > 0 ? (
                    <RenderFilters filters={filters} />
                ) : (
                    ''
                )}
                <Table
                    path="/fleet/jobs/"
                    deletePath="/fleet/jobs/"
                    callBeforeDrawerClosed={handleClose}
                    Form={JobsForm}
                    withPagination
                    query={query}
                    refresh={refresh}
                    headers={[
                        {
                            key: 'address',
                            label: 'common.form-label.address'
                        },
/*                         {
                            key: 'date',
                            type: 'date',
                            label: 'common.labels.date'
                        }, */
                        {
                            key: 'description',
                            label: 'common.form-label.descripcion'
                        },
                        {
                            key: 'status',
                            label: 'common.label.estado'
                        }
                    ]}
                />
            </>
        </PageBody>
    );
};